module.exports = __webpack_public_path__ + "img/diamonds-4.32e5de85.svg";